import * as scale from 'd3-scale'

function getGroupScale (breakdown, layout, plotScale, dimensions) {
  const chartTypes = layout.getTypes()
  const _scale = scale.scaleBand().domain(breakdown.map(d => d.id)) // domain is the ids

  if (chartTypes.length === 1 && chartTypes[0] === 'polar') {
    _scale.range([0, Math.PI * 2]) // The x axis uses angles in the polar chart
  } else {
    _scale.range([0, plotScale.bandwidth() - layout.rightMarginOffset]) // Decrease the width of the group scale by the right margin offset
          .paddingInner(dimensions.padding.group.inner)
          .paddingOuter(dimensions.padding.group.outer)
  }

  return _scale
}

export default function (layout, dimensions) {
  let plots = layout.plots.map(p => p.id)
    , plotScale = scale.scaleBand()
                       .domain(plots)
                       .range([0, dimensions.width])
                       .paddingInner(plots.length > 1 ? dimensions.padding.plot.inner : 0)
                       .paddingOuter(plots.length > 1 ? dimensions.padding.plot.outer : 0)
    , groupScale = getGroupScale(layout.breakdown.range, layout, plotScale, dimensions)

  return {
    center: function (d) {
      return groupScale(d) + groupScale.bandwidth() / 2
    },
    plotScale,
    groupScale
  }
}
